const API_URL = window.location.host
export {
    API_URL
}


//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = null
// module chunks = 